export default __webpack_public_path__ + "static/media/LegoWedo.906e9262.png";